import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";

const BACK_URL = "login_back_url";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  const { fullPath, name } = router.currentRoute;

  if (isWeixin()) {
    if (cookie.has("wx_bind_phone")) {
      router.push({ path: "/wx-bind-phone"});
    } else {
      oAuth();
    }
  } else {
    cookie.set(BACK_URL, backUrl || fullPath);
    if (name !== "Login") {
      push
        ? router.push({ path: "/login" })
        : router.replace({ path: "/login" });
    }
  }
}
